import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import IconButton from "../../Components/IconButton";
import MasKInput from "../../Components/IconInputField";
import SmartImage from "../../Components/SmartImage";
import CustomText from "../../Components/Text";
import Colors from "../../Constant/Colors";
import images from "../../Constant/images";
import { FONTS, STYLES } from "../../Constant/Theme";
import { TextLink } from "../LoginPage/styles";

const ForgetPasswordPage = ({ isMailSent, handleMailSent, auth }) => {
  const initialValues = {
    email: "",
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Email is required"),
  });

  const onSubmit = (values) => {
    // console.log('onSubmit',values);
    handleMailSent(values);
    // setSubmitting(false);
  };
  const customStyles = {
    image: {
      width: 40,
      height: 40,
      objectFit: "contain",
      marginRight: 10,
    },

  }
  return (
    <div style={{ padding: 20, ...STYLES.VerticalAlign }}>
      <div style={{ ...STYLES.HorizontalAlign, marginBottom: 100 }}>
        <SmartImage
          src={images.logo}
          alt="homepage"
          style={customStyles.image}
        />
        <CustomText
          style={{ ...FONTS.SemiBold28, color: Colors.primary }}
          text={"Power Education"}
        />
      </div>

      <div style={{ ...STYLES.VerticalAlign, width: "25%", minWidth: 250 }}>
        {isMailSent && (
          <SmartImage
            src={images.verify_mail}
            style={{ height: 120, width: 120 }}
          />
        )}
        <CustomText
          text={isMailSent ? "Verify your Email" : "Reset your password"}
          style={{ ...FONTS.Bold18, marginBottom: 20 }}
        />
        <CustomText
          text={
            isMailSent
              ? "Thank you, check your email for instructions to reset your password"
              : "Enter the email address associated with your account and we will send you a link to reset your password."
          }
          style={{ color: Colors.lightTxt }}
        />
        <div style={{ marginTop: 20, marginBottom: 20, width: "100%" }}>
          {!isMailSent && (
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({ isSubmitting,values }) => (
                <Form>
                  <Field
                    as={MasKInput}
                    name="email"
                    placeholder="Email"
                    icon={images.mail}
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    style={{ color: Colors.dangerColor }}
                  />
                  <IconButton
                    text={isMailSent ? "Skip Now" : "Continue"}
                    type="submit"
                    auth={isSubmitting}
                    disabled={isSubmitting}
                    onClick={()=>onSubmit(values)}
                    loading={auth?.isLoading}
                  />
                </Form>
              )}
            </Formik>
          )}
        </div>
        {!isMailSent && (
          <TextLink to={"/"} style={{ alignSelf: "center" }}>
            Back to Sign In
          </TextLink>
        )}
        <p
          className="form-text text-center mt-4"
          style={{
            fontSize: 12,
            color: Colors.primary,
            textAlign: "center",
          }}
        >
          {isMailSent ? "Don’t receive an email? " : "Don’t have an account? "}{" "}
          <TextLink to={isMailSent ? null : "/"}>
            {isMailSent ? "Resend" : "Sign up"}
          </TextLink>
        </p>
      </div>
    </div>
  );
};

export default ForgetPasswordPage;
